"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.icon"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.icon-library"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** * Stateless component to draw Salute.
 * @param {string} wrapperClass CSS class that wraps the SearchButton component.
 * @returns {JSX} Component Salute JSX.
 */
var SearchButton = function SearchButton(_ref) {
  var wrapperClass = _ref.wrapperClass,
      classIcon = _ref.classIcon,
      title = _ref.title;
  return _react.default.createElement("button", {
    type: "submit",
    className: wrapperClass
  }, _react.default.createElement(_gerenciatdReact.default, {
    classIcon: classIcon,
    title: title
  }));
};

SearchButton.propTypes = {
  wrapperClass: _propTypes.default.string,
  configuration: _propTypes.default.shape({
    classIcon: _propTypes.default.string,
    title: _propTypes.default.string
  })
};
SearchButton.defaultProps = {
  wrapperClass: '',
  classIcon: _gerenciatdReact2.default.buscar,
  title: "Buscador"
};
var _default = SearchButton;
exports.default = _default;

//# sourceMappingURL=index.js.map